import { useMutation, useQuery, useQueryClient } from "react-query"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { PageTitle } from "../../../../_metronic/layout/core"
import PageSpinner from "../../../components/Spinner/PageSpinner"
import { getSetting, updateSetting } from "../../../models/settings"
import Authorization from "../../../routing/Authorization"
import SettingForm from "./SettingForm/SettingForm"

const breadcumbs = [
    {
        title: 'Settings',
        path: '/settings',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]

const EditSetting = () => {
    const navigate = useNavigate()
    const { settingId } = useParams()

    const queryClient = useQueryClient()
    const { isLoading, data: setting } = useQuery(['setting'], () => getSetting(settingId), {
        cacheTime: 0,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    })

    console.log(setting)
    const { mutate, isLoading: isSubmitLoading } = useMutation(data => updateSetting(settingId, data), {
        onSuccess: () => {
            queryClient.invalidateQueries(['courses'])
            toast.success('Success')
            navigate('/settings/website')
        },
        onError: error => toast.error(error?.response?.data?.message)
    })

    return (
        <>
            <PageTitle breadcrumbs={breadcumbs}>Edit Setting</PageTitle>
            <div className="card">
                <div className="card-body">
                    {isLoading ? <PageSpinner height={300} /> : (
                        <SettingForm
                            data={setting.data}
                            queryClient={queryClient}
                            onSubmit={values => mutate(values)}
                            isSubmitLoading={isSubmitLoading}
                        />
                    )}
                </div>
            </div>
        </>
    )
}

export default Authorization(EditSetting, ['admin', 'officer'])